import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarDismiss } from '@angular/material/snack-bar';
import { Observable } from 'rxjs';
import { SnackbarComponent } from '../components/snackbar/snackbar.component';

@Injectable({
  providedIn: 'root' // snackbar service, wrapper on mat-snackbar
})
export class SnackbarService {

  public defaultErrorMessage = 'Something went wrong. Please try again';

  constructor(
    private snackBar: MatSnackBar
  ) { }

  public show(text: string, className: string, duration: number = 5000): Observable<MatSnackBarDismiss> {
    const config = new MatSnackBarConfig();
    config.verticalPosition = 'top';
    config.horizontalPosition = 'center';
    config.duration = duration;
    config.panelClass = className;
    config.data = { text };

    return this.snackBar.openFromComponent(SnackbarComponent, config).afterDismissed();
  }

  public success(text): void {
    this.show(text, 'success');
  }

  public warning(text): void {
    this.show(text, 'warning');
  }

  public error(text = this.defaultErrorMessage, duration = 10000): void {
    this.show(text, 'error', duration);
  }

  public info(text, duration = 5000): void {
    this.show(text, 'info', duration);
  }

  public close(): void {
    this.snackBar.dismiss();
  }

}
